module.exports = __webpack_public_path__ + "static/power-img1-1-014b5586c7ec44828e714efda2138e66.png";